import { render, staticRenderFns } from "./rylb.vue?vue&type=template&id=06ce861a&scoped=true&"
import script from "./rylb.vue?vue&type=script&lang=js&"
export * from "./rylb.vue?vue&type=script&lang=js&"
import style0 from "./rylb.vue?vue&type=style&index=0&id=06ce861a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce861a",
  null
  
)

export default component.exports